import { render, staticRenderFns } from "./last.vue?vue&type=template&id=59bd38bc&scoped=true"
import script from "./last.vue?vue&type=script&lang=js"
export * from "./last.vue?vue&type=script&lang=js"
import style0 from "./last.vue?vue&type=style&index=0&id=59bd38bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd38bc",
  null
  
)

export default component.exports